// Il calcolo di resize() usa altezze fisse e sbaglia appena sopra o sotto la
// tabella c'è altro (pillole, "Spunta tutte", legende, righe più alte): la
// pagina sborda con una seconda scrollbar o lascia spazio vuoto in fondo. Qui
// la tabella si allunga o si accorcia perché la pagina riempia esattamente la
// finestra. Vale per la tabella principale di una pagina elenco, non per
// quelle nelle modali o nelle pagine con più tabelle.
// È un metodo dei componenti tabella (tables/template.vue e
// tables/template_lisaweb.vue): usa $el, height e, se c'è, isTableInModal.

// Spazio lasciato sotto la pagina e altezza minima della tabella.
const PAGE_BOTTOM_GAP = 16;
const MIN_TABLE_HEIGHT = 250;
// Spazio che la pagina occupa sotto la tabella a dati caricati (paginazione,
// pulsanti), misurato per pagina e ricordato anche fra una sessione e
// l'altra: in caricamento la paginazione sparisce e la tabella lo lascia
// libero. Non tutte le tabelle hanno la paginazione standard, quindi senza
// una misura non si riserva nulla.
const STORAGE_KEY = "lisaweb.tableFooterSpace";
const footerSpaces = (() => {
  try {
    const value = JSON.parse(localStorage.getItem(STORAGE_KEY));
    return value && typeof value === "object" && !Array.isArray(value)
      ? value
      : {};
  } catch (e) {
    return {};
  }
})();
const saveFooterSpace = (key, value) => {
  if (footerSpaces[key] === value) return;
  footerSpaces[key] = value;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(footerSpaces));
  } catch (e) {
    // senza storage la misura resta valida per questa sessione
  }
};

export function fitToPage() {
  const el = this.$el;
  const sticky = el?.querySelector?.(".b-table-sticky-header");
  const scroller = el?.closest?.(".dashboard");
  const page = el?.closest?.(".main-content > *");
  if (!sticky) return;
  // Fuori da una pagina elenco (modali, tabelle dentro un form) la tabella
  // torna alla sua altezza normale.
  const unfit = () => {
    if (sticky.dataset.fit === undefined) return;
    delete sticky.dataset.fit;
    sticky.style.height = "";
    sticky.style.removeProperty("--busy-height");
  };
  if (!scroller || !page || el.closest(".modal") || this.isTableInModal) {
    return unfit();
  }
  const tables = [
    ...scroller.querySelectorAll(".main-content .b-table-sticky-header"),
  ].filter((t) => t.offsetParent && !t.closest(".b-table-details"));
  if (tables.length !== 1 || tables[0] !== sticky) return unfit();
  const view = scroller.getBoundingClientRect();
  const pageBottom = page.getBoundingClientRect().bottom;
  const bottom = pageBottom + scroller.scrollTop;
  // In caricamento la paginazione sparisce: la tabella resta alta quanto
  // sarà a dati arrivati, invece di allungarsi e poi riaccorciarsi. Le
  // tabelle con la paginazione standard al suo posto mostrano i segnaposto
  // (PaginationSkeleton), alti uguali: per loro il calcolo è quello normale.
  const busy =
    !!sticky.querySelector(".b-table-busy-slot") &&
    !el.querySelector(".pagination-skeleton");
  const below = pageBottom - sticky.getBoundingClientRect().bottom;
  // Chiave: lo schema della rotta (es. /x/:id/edit), non il percorso con
  // gli id, così le voci non crescono a ogni record aperto.
  const matched = this.$route?.matched || [];
  const key = matched.length
    ? matched[matched.length - 1].path
    : this.$route?.path;
  if (!busy && el.querySelector(".pagination-wrapper")) {
    saveFooterSpace(key, Math.round(below));
  }
  const stored = footerSpaces[key];
  const measured =
    busy && !this.noPagination && Number.isFinite(stored) && stored >= 0;
  const reserve = measured ? Math.max(0, stored - below) : 0;
  // Un contenitore fra tabella e pagina che scorre per conto suo (es.
  // [data-type=overflow-x] con un'altezza imposta) assorbe lo sbordamento:
  // la pagina non sborda ma compare una seconda scrollbar. Si sottrae.
  let nested = 0;
  for (let a = sticky.parentElement; a && a !== scroller; a = a.parentElement) {
    if (/(auto|scroll)/.test(getComputedStyle(a).overflowY)) {
      nested += Math.max(0, a.scrollHeight - a.clientHeight);
    }
  }
  const free =
    view.top +
    scroller.clientHeight -
    PAGE_BOTTOM_GAP -
    bottom -
    nested -
    reserve;
  // Senza una misura (prima visita, paginazione non standard) in
  // caricamento resta l'altezza di prima, come sempre.
  const height =
    busy && !measured && parseInt(this.height)
      ? parseInt(this.height)
      : Math.abs(free) < 1
        ? sticky.offsetHeight
        : Math.max(MIN_TABLE_HEIGHT, Math.floor(sticky.offsetHeight + free));
  if (`${height}px` !== this.height) this.height = `${height}px`;
  // Altezza piena anche con pochi risultati: la paginazione resta in fondo
  // e la pagina non cambia forma (sfondo e bordo in _tables.scss).
  sticky.style.height = `${height}px`;
  sticky.dataset.fit = "";
  // Il loader (riga busy) occupa l'altezza della tabella sotto la testata:
  // così sta al centro dello spazio della tabella (vedi _tables.scss).
  const thead = sticky.querySelector("thead");
  sticky.style.setProperty(
    "--busy-height",
    `${height - (thead?.offsetHeight || 0)}px`,
  );
}
